import React from 'react';
import { Button, Grid } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { makeStyles } from '@material-ui/styles';
import TieredLineItemRateRule from './TieredLineItemRateRule';
import { generateTestId } from '../../../../../../utils';
import { tieredRateFormDefault } from './line-item-config-form-utils';

// The form for adding a 'tiered' line item rate with more complex conditional rules
function TieredLineItemRate({ name, disabledOnEdit = false }) {
    const { control } = useFormContext();

    const useStyles = makeStyles((theme) => ({
        container: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(2),
            backgroundColor: theme.palette.background.default,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: theme.palette.divider,
            borderRadius: theme.shape.borderRadius,
        },
        buttonContainer: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
    }));
    const classes = useStyles();

    const { fields, append, remove } = useFieldArray({
        control,
        name: `${name}.rules`,
    });

    const addRule = () => {
        append(tieredRateFormDefault);
    };

    return (
        <div>
            {fields.map((field, index) => (
                <Grid key={field.id} className={classes.container}>
                    <TieredLineItemRateRule name={`${name}.rules.${index}`} index={index} removeRule={() => remove(index)} disabledOnEdit={disabledOnEdit} />
                </Grid>
            ))}
            <Grid container className={classes.buttonContainer}>
                <Button variant="outlined" onClick={addRule} data-testid={generateTestId(name, 'add-rule-btn')} disabled={disabledOnEdit}>
                    Add Rule
                </Button>
            </Grid>
        </div>
    );
}

export default TieredLineItemRate;
